import { OnInit, OnDestroy } from '@angular/core';

import { Subject } from 'rxjs';

import { Settings, SettingsService } from '../../settings';
import { LocalStoreManager } from '../services/local-store-manager.service';

//exports
export { Settings, SettingsService } from '../../settings';
export { LocalStoreManager } from '../services/local-store-manager.service';

export class PageBaseComponent implements OnInit, OnDestroy {
  protected ngUnsubscribe = new Subject();

  public loading: boolean = false;//public to be used in template
  public settings: Settings;//public to be used in template

  constructor(
    protected readonly settingsService?: SettingsService,
    protected readonly localStorage?: LocalStoreManager
  ) {
  }

  ngOnInit() {
    if (this.settingsService) {
      this.settings = this.settingsService.get();
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  protected loadData(): void {
    this.loading = true;
  }

  protected loadLocalStore<TKey>(key: string) {

    if (this.localStorage && this.localStorage.exists(key))
      return this.localStorage.getDataObject<TKey>(key);
  }
  protected saveToLocalStore(data: any, key: string) {
    setTimeout(() => {
      if (this.localStorage)
        this.localStorage.saveSessionData(data, key)
    });
  }
}
